const allPromos = [
    {
        sportkey: "golf",
        code: "ANALYZERM26",
        expires: "2026-05-20",
        name: "PGA Special",
        description: "7 days free then $0.99/month.",
        normalPrice: "$2.99/month",
        globalTag: "7 days free"
    },
    {
        sportkey: "global",
        code: "ANALYZERM26",
        expires: "2026-05-20",
        name: "PGA Special",
        description: "7 days free then $0.99/month.",
        normalPrice: "$2.99/month",
        globalTag: "7 days free"
    },
    {
        sportkey: "cricket_off",
        code: "ANALYZER26",
        expires: "2026-05-31",
        name: "New Season Special",
        description: "Try free for 30 days, then just $9.99/year.",
        normalPrice: "$29.99/year",
        globalTag: "30 days free"
    }
]

const getPromo = (key) => {
    const promo = allPromos.find(p => p.sportkey === key);

    if(promo && new Date(promo.expires) > new Date())
    {
        return promo;
    }

    return null;
}


export {getPromo}